<template>
  <div :class="['documents-card medium-border-radius offwhite-bg']">
    <div class="card-content ph-2 pt-2" >
      <ul class="files-list columns gap2" v-if="docs.length > 0">
        <li class="flex ai-c jc-sb fgap2 pb-2 span-12" v-for="(doc, index) in docs" :key="index">
          <div class="flex ai-c fgap1">
            <div class="flex ai-c fgap1">
              <span v-if="verifyDocIcon(doc.originalFilename) === 'pdf'">
                <img src="@/assets/img/pdf.png" width="60px" height="60px" alt="PDF">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'xml'">
                <img src="@/assets/img/xml.png" width="60px" height="60px" alt="XML">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'png'">
                <img src="@/assets/img/png.png" width="60px" height="60px" alt="PNG">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'jpeg'">
                <img src="@/assets/img/jpg.png" width="60px" height="60px" alt="JPEG">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'jpg'">
                <img src="@/assets/img/jpg.png" width="60px" height="60px" alt="JPG">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'xlsx'">
                <img src="@/assets/img/xls.png" width="60px" height="60px" alt="XLSX">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'general'">
                <img src="@/assets/img/archive.png" width="60px" height="60px" alt="ARQUIVO">
              </span>
              <div>
                <p class="text-bold">{{ doc.fileType }}</p>
                <p class="doc-description text-md">{{ doc.originalFilename }} </p>
              </div>
            </div>
          </div>

          <div class="flex gap1">
            <button type="button"
                    @click.prevent="() => downloadDocument(doc.id, doc.originalFilename, doc.code)"
                    class="btn solid primary text-uppercase small">DOWNLOAD
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

import {
  PdfIcon,
} from '@/components/Icons';

export default {
  name: 'DocumentsCard',
  components: {
    PdfIcon,
  },
  methods: {
    async downloadDocument(docId, originalFilename, docCode) {
      try {
        const response = await api.get(`/freightQuotation/retrieve/${this.quoteData.codigo}/document/${docId}/docCode/${docCode}/download`, {
          responseType: 'text',
        });

        const base64 = response.data;
        const binaryString = window.atob(base64);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        const type = this.getMimeType(originalFilename);
        const blob = new Blob([bytes], { type });
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', originalFilename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        this.$toast.error('Não foi possível fazer o download do documento!');
      }
    },
    getMimeType(filename) {
      const ext = (filename?.split('.').pop() || '').toLowerCase();
      const map = {
        pdf: 'application/pdf',
        xml: 'application/xml',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      };
      return map[ext] || 'application/octet-stream';
    },
    verifyDocIcon(originalFilename) {
      const reg = [
        {
          type: 'pdf',
          reg: new RegExp('.pdf', 'gi'),
        },
        {
          type: 'jpeg',
          reg: new RegExp('.jpeg', 'gi'),
        },
        {
          type: 'jpg',
          reg: new RegExp('.jpg', 'gi'),
        },
        {
          type: 'png',
          reg: new RegExp('.png', 'gi'),
        },
        {
          type: 'xml',
          reg: new RegExp('.xml', 'gi'),
        },
        {
          type: 'xlsx',
          reg: new RegExp('.xlsx', 'gi'),
        },
      ];

      let type = 'general';

      reg.forEach((r) => {
        if (r.reg.test(originalFilename)) {
          type = r.type;
        }
      });

      return type;
    },
  },
  props: {
    docs: {
      type: Array,
      default: () => [],
    },
    quoteData: {
      type: Object,
      default: () => {
      },
    },
  },
};
</script>

<style scoped>
.files-list:not(.missing) li:not(:last-of-type) {
  border-bottom: var(--input-border);
}

.files-list.missing li {
  border-bottom: var(--input-border);
}

.doc-description {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-user {
  font-size: 0.85rem;
}
</style>
